import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetCartItems, GetCartItemsCount, GetPriceRule, DuplicateCart, DeleteCart } from './module';
import moment from 'moment';

const initialState = {
    pages_data: null,
    cartCountInfo: null,
    isLoadShop: false,
    test: null,
    shopInfo: {
        name: null,
        code: null,
        count: 0
    },
    formSubmitted: false,
    priceRules: null,
    isSelectedAllItems: false,
    isSomeItemSelected: true,
    formValid: false,
    CartItems: [],
    shoppingCart: {
        viewOnsite: {
            items: []
        },
        subjectToApproval: {
            items: [],
            flatItems: [],
            totalItemsCount: 0,
            totalItemsAmount: 0,
            totalWithGstAmount: 0,
            aafee: 0,
            totalAafee: 0,
            gstAmount: 0,
            minusAmount: 0,
            accessionNumbers: [],
            totalItemsAmountAndTotalAafee: 0,
            finalAmount: 0
        },
        availableAfterPayment: {
            items: [],
            totalItemsAmount: 0,
            totalWithGstAmount: 0,
            aafee: 0,
            totalAafee: 0,
            gstAmount: 0,
            minusAmount: 0,
            accessionNumbers: [],
            totalItemsAmountAndTotalAafee: 0,
            finalAmount: 0
        }
    },
    status: "idle",
    ActionStatus: "",
    errorMessage: ""
};

const pageStringToTotalPage = (pageString) => {
    var totalPage = 0;
    pageString.split(',').map((v) => {
        v = v.trim();
        if (v === '') {
            return false;
        }

        if (v.indexOf('-') !== -1) {
            v = v.split('-');
            totalPage = totalPage + (+v[1] - +v[0]) + 1;
            //return (+v[1] - +v[0]) + 1;
        } else {
            totalPage = totalPage + 1;
            // return 1;
        }
    });
    return totalPage;
}

const sum = (array, getNumberFn) => {
    getNumberFn = getNumberFn || function (item) {
        return item
    }
    return array.reduce(function (result, item) {
        return result + getNumberFn(item);
    }, 0);
};

const distinct = (array, compare) => {
    compare = compare || function (a, b) {
        return a === b;
    }
    var a = array;
    var b = [];
    for (var i = 0; i < a.length; i++) {
        var ok = true;
        var aValue = a[i];
        for (var j = 0; j < b.length; j++) {
            var bValue = b[j];
            var same = compare(aValue, bValue);
            if (same) {
                ok = false;
                break;
            }
        }
        if (ok) b.push(a[i]);
    }
    return b;
}

const groupBy = (array, compareWith) => {
    compareWith = compareWith || function (a, b) {
        return a === b;
    }
    var datas = array.slice();
    var results = [];
    while (datas.length > 0) {
        var result = [];
        var aData = datas.pop();
        result.unshift(aData);
        for (var i = datas.length - 1; i >= 0; i--) {
            var bData = datas[i];
            var match = compareWith(aData, bData);
            if (match) {
                result.unshift(bData);
                datas.splice(i, 1);
            }
        }
        results.unshift(result);
    }
    return results;
}

const typeOf = (value) => {
    return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
}

const isDate = (value) => {
    return typeOf(value) === 'date';
}

const isSameValue = (a, b) => {
    if (a === b) return true;
    if (isDate(a) && isDate(b)) {
        return +a === +b || (isNaN(+a) && isNaN(+b));
    }
}

const orderBy = (array, commands, needClone) => {
    if (needClone === undefined) needClone = true;
    var sortCompare = function (a, b, desc) {
        if (desc === undefined) desc = false;
        var asc = !desc;
        if (isSameValue(a, b)) return 0;
        if (asc) {
            if (a == null || b == null) {
                return (b == null) ? -1 : 1;
            }
            if (typeof (a) === 'boolean') {
                return (a === true && b === false) ? -1 : 1;
            } else if (typeof (a) === 'number') {
                return (a < b) ? -1 : 1;
            } else if (isDate(a)) {
                return (+a < +b) ? -1 : 1;
            } else if (typeof (a) === 'string') {
                var isChinese = a.charCodeAt(0) >= 10000;
                var result = (isChinese) ? a.localeCompare(b, 'zh-CN') : a.localeCompare(b);
                return result;
            } else {
                return '';
            }
        } else {
            if (a == null || b == null) {
                return (a == null) ? -1 : 1;
            }
            if (typeof (a) === 'boolean') {
                return (b === true && a === false) ? -1 : 1;
            } else if (typeof (a) === 'number') {
                return (b < a) ? -1 : 1;
            } else if (isDate(a)) {
                return (+b < +a) ? -1 : 1;
            } else if (typeof (a) === 'string') {
                var isChinese = a.charCodeAt(0) >= 10000;
                var result = (isChinese) ? b.localeCompare(a, 'zh-CN') : b.localeCompare(a);
                return result;
            } else {
                return '';
            }
        }
    }

    if (needClone) array = array.slice();

    var tryRemoveCommandDescSymbol = function (command) {
        return (command.charAt(0) === '-') ? command.substring(1) : command;
    }

    return array.sort(function (o1, o2) {
        for (var i = 0; i < commands.length; i++) {
            var command = commands[i];
            let a = (typeof (command) === 'string') ? o1[tryRemoveCommandDescSymbol(command)] : command.getValue(o1);
            let b = (typeof (command) === 'string') ? o2[tryRemoveCommandDescSymbol(command)] : command.getValue(o2);
            const result = sortCompare(a, b, (typeof (command) === 'string') ? command.charAt(0) === '-' : command.desc);
            if (result === 0) {
                continue;
            } else {
                return result;
            }
        }
        return '';
    });
};

export const GetCartItemsAsync = createAsyncThunk(
    'cart/GetCartItems',
    async (data, ThunkAPI) => {
        const response = await GetCartItems(data);
        const resultPromise = Promise.resolve(response);
        resultPromise.then((data, index) => {
            if (data && data.Status === 'OK') {
                if (sessionStorage.getItem('cartItems')) {
                    ThunkAPI.dispatch(shopInitial(data));
                } else {
                    ThunkAPI.dispatch(cartCalculation(data));
                }
            }

        })

        return response;
    }
);

export const GetPriceRuleAsync = createAsyncThunk(
    'cart/GetPriceRule',
    async (data, ThunkAPI) => {
        const response = await GetPriceRule();
        const resultPromise = Promise.resolve(response);
        resultPromise.then(() => {
            ThunkAPI.dispatch(GetCartItemsAsync(data));
        })

        return response;
    }
);

export const GetCartItemsCountAsync = createAsyncThunk(
    'cart/GetCartItemsCount',
    async (count_data, ThunkAPI) => {
        const response = await GetCartItemsCount();
        const resultPromise = Promise.resolve(response);
        resultPromise.then((data, index) => {
            if (data && data.Status === 'OK') {
                if (count_data) {
                    ThunkAPI.dispatch(GetCartItemsAsync({ ShopCode: count_data.shopCode }));
                } else {
                    var getShop = data.shops ? data.shops.filter((data) => data.CartItemCount > 0) : null;
                    if (getShop && getShop.length > 0) {
                        ThunkAPI.dispatch(GetPriceRuleAsync({ ShopCode: getShop[0].ShopCode }));
                    }
                }

            } else {
                alert('Your session has timeout!');
            }

        })
        return response;
    }
);

export const DuplicateCartAsync = createAsyncThunk(
    'cart/DuplicateCart',
    async (data, ThunkAPI) => {
        const response = await DuplicateCart(data.items);
        const resultPromise = Promise.resolve(response);
        resultPromise.then(() => {
            ThunkAPI.dispatch(GetCartItemsCountAsync({ shopCode: data.code }));
        })
        return response;
    }
);

export const DeleteCartAsync = createAsyncThunk(
    'cart/DeleteCart',
    async (data, ThunkAPI) => {
        const response = await DeleteCart(data);
        return response;
    }
);

export const CartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        submitCart: (state, action) => {
            state.formSubmitted = true;
            if (state.formValid) {
                window.wogaaCustom.startTransactionalService('ArchivesOnline-2860');
                sessionStorage.setItem('shoppingCart', JSON.stringify(state.shoppingCart));
                sessionStorage.setItem('shopCode', state.shopInfo.code);
                state.status = 'loading';
                setTimeout(() => {
                    window.location.href = "./archival/form";
                }, 1000);
            }
        },
        selectAllItems: (state, action) => {
            state.CartItems.forEach((item, index) => {
                item.checked = !state.isSelectedAllItems;
            });
        },
        toggleSubmit: (state, action) => {
            state.formSubmitted = true;
        },
        changeShopInfo: (state, action) => {
            state.shopInfo = {
                name: action.payload.name,
                code: action.payload.code,
                count: action.payload.count
            };
        },
        updateCartItem: (state, action) => {
            var id = action.payload.id;
            var value = action.payload.value;
            var CartItems = state.CartItems;
            var name = action.payload.name;
            var updateData = CartItems.filter((item) => item.CartItemId === id);

            switch (name) {
                case 'Start_Time':
                    updateData[0].Start_Time = value;
                    break;
                case 'End_Time':
                    updateData[0].End_Time = value;
                    break;
                case 'Format':
                    updateData[0].Format = value;
                    break;
                case 'FullOrPartial':
                    updateData[0].FullOrPartial = value;
                    break;
                case 'First_Few_Words':
                    updateData[0].First_Few_Words = value;
                    updateData[0].First_Few_Words_touched = 1;
                    break;
                case 'Last_Few_Words':
                    updateData[0].Last_Few_Words = value;
                    updateData[0].Last_Few_Words_touched = 1;
                    break;
                case 'PagesNeeded':
                    updateData[0].PagesNeeded = value;
                    break;
                case 'checked':
                    updateData[0].checked = value;
                    break;
                default:
            }

        },
        cartCalculation: (state, action) => {
            var data = action.payload;
            state.CartItems = data.CartItems;
            state.formValid = true;

            state.isSelectedAllItems = state.CartItems.every(function (item) {
                return item.checked;
            });

            state.isSomeItemSelected = state.CartItems.some(function (item) {
                return item.checked;
            });

            //VO Start
            state.shoppingCart.viewOnsite.items = state.CartItems.filter(function (item) {
                return item.TypeCode === "VO";
            });
            
            orderBy(state.shoppingCart.viewOnsite.items, ['CategoryDescription', 'SourceTitle'], false);
            //VO End

            //AP Start
            state.shoppingCart.availableAfterPayment.items = state.CartItems.filter(function (item) {
                return item.TypeCode === "AP";
            });

            orderBy(state.shoppingCart.availableAfterPayment.items, ['CategoryDescription', 'SourceTitle'], false);

            if (state.shoppingCart.availableAfterPayment.items.length > 0) {
                state.shoppingCart.availableAfterPayment.items.forEach((item, index) => {
                    var priceList = state.priceRules.filter((price) => price.CategoryCode === item.CategoryCode && (!price.Format || price.Format.toLowerCase() === (item.Format || "").toLowerCase()));
                    priceList.forEach((price) => {
                        if (price.CategoryCode === item.CategoryCode && (!price.Format || price.Format.toLowerCase() === (item.Format || "").toLowerCase())) {
                            item.Price = price.SetPrice;
                            item.UOM = price.UOM;
                            item.GSTPrice = price.GSTPrice;
                        }
                    });

                    state.shoppingCart.availableAfterPayment.totalWithGstAmount =parseFloat(state.shoppingCart.availableAfterPayment.totalWithGstAmount) + parseFloat(item.GSTPrice);
                });
                state.shoppingCart.availableAfterPayment.totalItemsAmount = state.shoppingCart.availableAfterPayment.items.reduce((a, { Price }) => a + Price, 0);
            }
            //AP End

            state.shoppingCart.subjectToApproval.totalItemsAmount = 0;
            state.shoppingCart.subjectToApproval.totalWithGstAmount = 0;
            var subjectToApprovalItems = state.CartItems.sort((a, b) => (a.CategoryDescription - b.CategoryDescription && a.SourceTitle - b.SourceTitle)).filter(function (item) {
                return item.TypeCode === "SA";
            });

            subjectToApprovalItems.forEach(function (item) {
                item.Start_Time = item.Start_Time ? item.Start_Time : '00:00:01';
                item.End_Time = item.End_Time ? item.End_Time : '00:00:02';
                item.First_Few_Words = item.First_Few_Words ? item.First_Few_Words : "";
                item.Last_Few_Words = item.Last_Few_Words ? item.Last_Few_Words : "";
                item.Last_Few_Words_touched = item.Last_Few_Words_touched ? item.Last_Few_Words_touched : 0;
                item.First_Few_Words_touched = item.First_Few_Words_touched ? item.First_Few_Words_touched : 0;

                if (item.Start_Time && item.End_Time) {
                    var startDuration = moment.duration(moment(item.Start_Time, 'HH:mm:ss'));
                    var endDuration = moment.duration(moment(item.End_Time, 'HH:mm:ss'));

                    var gap = endDuration.subtract(startDuration).asMilliseconds();
                    if (gap > 0) {
                        item.Duration = moment.utc(gap).format('HH:mm:ss');
                    } else {
                        item.Duration = '';
                    }
                }

                if (item.PagesNeeded) {
                    item.TotalSelected = pageStringToTotalPage(item.PagesNeeded);

                } else {
                    item.TotalSelected = item.TotalPageCount;
                }
            });

            state.shoppingCart.subjectToApproval.flatItems = subjectToApprovalItems;
            state.shoppingCart.subjectToApproval.totalItemsCount = subjectToApprovalItems.length;
            var validateDate = [];
            var validateWords = [];
            var TimeErrorList = [];

            state.shoppingCart.subjectToApproval.items = groupBy(subjectToApprovalItems, function (a, b) {
                return a.CategoryCode + a.Format + a.FullOrPartial === b.CategoryCode + b.Format + b.FullOrPartial;
            }).map((items, index) => {

                var item = items[0];

                if (item.FullOrPartial === 'Full') {

                    var totalAmount = 0;
                    items.forEach((item) => {
                        var priceList = state.priceRules.filter((price) => price.CategoryCode === item.CategoryCode &&
                            (!price.Format || price.Format.toLowerCase() === (item.Format || "").toLowerCase()) &&
                            (!price.FullOrPartial || price.FullOrPartial.toLowerCase() === (item.FullOrPartial || "").toLowerCase()));
                        priceList.forEach((price) => {
                            if (price.CategoryCode === item.CategoryCode &&
                                (!price.Format || price.Format.toLowerCase() === (item.Format || "").toLowerCase()) &&
                                (!price.FullOrPartial || price.FullOrPartial.toLowerCase() === (item.FullOrPartial || "").toLowerCase())) {

                                var UOM = price.UOM;
                                item.UOM = UOM;
                                item.UnitPerSet = price.UnitPerSet;
                                if (UOM === 'item') {
                                    item.Price = price.SetPrice;
                                    item.GSTPrice = price.GSTPrice;
                                } else if (UOM === 'page') {
                                    item.Price = Math.ceil(+item.PageCount / price.UnitPerSet) * price.SetPrice;
                                    item.GSTPrice = Math.ceil(+item.PageCount / price.UnitPerSet) * price.GSTPrice;
                                } else {
                                    item.UOM = '';
                                    // UOM = 'seconds' | 'minutes' | 'hours'
                                    var itemDuration = moment.duration(Math.floor(item.TotalDuration), 'seconds');
                                    var itemDurationInUOM = Math.ceil(itemDuration.as(price.UOM));
                                    var block = Math.ceil(itemDurationInUOM / price.UnitPerSet);
                                    item.GSTPrice = block * price.GSTPrice;
                                    item.Price = block * price.SetPrice;

                                }
                                totalAmount += item.Price;
                            }
                        })

                        state.shoppingCart.subjectToApproval.totalItemsAmount += item.Price;
                        state.shoppingCart.subjectToApproval.totalWithGstAmount = parseFloat(state.shoppingCart.subjectToApproval.totalWithGstAmount) + parseFloat(item.GSTPrice);
                    });

                    orderBy(items, ['SourceTitle'], false);

                    return {
                        groupKey: item.CategoryCode + item.Format + item.FullOrPartial,
                        firstItem: item,
                        items: items
                    }
                } else {
                    var result = {
                        firstItem: item,
                        totalAmount: 0,
                        totalGSTAmount: 0,
                        totalPage: 0,
                        isPageExceed: false,
                        totalSelectedDuration: '',
                        totalItem: items.length,
                        accessionGroups: [],
                        groupKey: item.CategoryCode + item.Format + item.FullOrPartial,
                    }

                    result.accessionGroups = groupBy(items, (a, b) => {
                        //return a.ObjectID === b.ObjectID;
                        return a.SourceNo === b.SourceNo;

                    }).map(function (items) {
                        orderBy(items, ['SourceTitle'], false);

                        var item = items[0];

                        if (item.Format === 'MP3' || item.Format === 'MP4' || item.Format === 'MXF') {
                            var checkTime = false;
                            var getTotalDuration = moment.duration(moment.duration(Math.floor(item.TotalDuration), 'seconds').asMilliseconds());
                            var currentHours = getTotalDuration.hours();
                            currentHours = ("0" + currentHours).slice(-2);
                            var currentMinutes = getTotalDuration.minutes();
                            currentMinutes = ("0" + currentMinutes).slice(-2);
                            var currentSeconds = getTotalDuration.seconds();
                            currentSeconds = ("0" + currentSeconds).slice(-2);

                            var maxDuration = currentHours + ":" + currentMinutes + ":" + currentSeconds;

                            items.forEach(function (anItem) {

                                var validateTime = (anItem.End_Time < anItem.Start_Time) ? true : (anItem.Start_Time > maxDuration) ? true : (anItem.End_Time > maxDuration) ? true : (anItem.End_Time === anItem.Start_Time || anItem.Start_Time === anItem.End_Time) ? true : false;
                                if (validateTime) {
                                    var getErrorItems = {
                                        timeError: validateTime,
                                        item: anItem
                                    }
                                    TimeErrorList.push(getErrorItems);
                                }

                                validateDate.push(validateTime);

                                if (anItem.First_Few_Words_touched === 0 || anItem.First_Few_Words_touched === 0) {
                                    validateWords.push(false);
                                }
                                if (item.First_Few_Words_touched && !item.First_Few_Words) {
                                    validateWords.push(false);
                                }
                                if (item.Last_Few_Words_touched && !item.Last_Few_Words) {
                                    validateWords.push(false);
                                }
                            });

                            if (validateDate.includes(true)) {
                                state.formValid = false;
                                checkTime = true;
                            } else if(validateWords.length > 0){
                                state.formValid = false;
                            } else {
                                state.formValid = true;
                                checkTime = false;
                            }

                        }

                        var totalSelectedDuration = '';
                        var allowDuration = '';
                        var leftDuration = '';
                        var isOverAllowDuration = false;
                        if (item.Duration) {
                            totalSelectedDuration = moment.duration('00:00:00');
                            items.forEach((item) => {
                                var duration = moment.duration(item.Duration);
                                totalSelectedDuration.add(duration);
                            });

                            if (item.CategoryCode === 'AV') {
                                allowDuration = moment.duration(moment.duration(Math.floor(item.TotalDuration), 'seconds').asMilliseconds() * 25 / 100);
                                leftDuration = allowDuration.subtract(totalSelectedDuration);
                                if (leftDuration.asMilliseconds() < 0) isOverAllowDuration = true;
                                leftDuration = moment.utc(leftDuration.asMilliseconds()).format('HH:mm:ss');
                                allowDuration = moment.utc(allowDuration.asMilliseconds()).format('HH:mm:ss');
                            }
                            totalSelectedDuration = moment.utc(totalSelectedDuration.asMilliseconds()).format('HH:mm:ss');
                        }
                        if (state.formValid && isOverAllowDuration) state.formValid = false;

                        return {
                            ObjectDispID: item.SourceNo,
                            totalSelectedDuration: totalSelectedDuration,
                            allowDuration: allowDuration,
                            isOverAllowDuration: isOverAllowDuration,
                            checkTime: checkTime,
                            TimeErrorList: TimeErrorList,
                            items: items
                        }
                    });
                    orderBy(result.accessionGroups, ['SourceNo'], false);

                    var priceList = state.priceRules.filter((price) => price.CategoryCode === item.CategoryCode &&
                        (!price.Format || price.Format.toLowerCase() === (item.Format || "").toLowerCase()) &&
                        (!price.FullOrPartial || price.FullOrPartial.toLowerCase() === (item.FullOrPartial || "").toLowerCase()));

                    priceList.forEach((price) => {
                        if (price.CategoryCode === item.CategoryCode &&
                            (!price.Format || price.Format.toLowerCase() === (item.Format || "").toLowerCase()) &&
                            (!price.FullOrPartial || price.FullOrPartial.toLowerCase() === (item.FullOrPartial || "").toLowerCase())) {
                            var UOM = price.UOM;
                            item.UnitPerSet = price.UnitPerSet;
                            item.UOM = UOM;
                            if (UOM === 'item') {
                                result.totalAmount = items.length * price.SetPrice;
                                result.totalGSTAmount = items.length * price.GSTPrice;
                            } else if (UOM === 'page') {
                                result.totalPage = sum(items.filter((item) => {
                                    return item.TotalSelected
                                }), function (item) {
                                    return item.TotalSelected;
                                });
                                if (item.TotalSelected === 0) state.formValid = false;
                                if (item.PagesNeeded) {
                                    var selectedPages = item.PagesNeeded;
                                    var pagesError = false;
                                    result.checkPages = sum(selectedPages.split(',').map((v) => {
                                        if (v === '') {
                                            pagesError = true;
                                        } else {
                                            pagesError = false;
                                        }
                                        return pagesError;
                                    }));

                                    if (!item.TotalSelected || item.TotalSelected > item.TotalPageCount || pagesError || item.PagesNeeded.charAt(0) === ',') {
                                        item.pagesError = true;
                                        state.formValid = false;

                                    } else {
                                        item.pagesError = false;
                                        state.formValid = true;

                                    }
                                }

                                result.totalAmount = Math.ceil(result.totalPage / price.UnitPerSet) * price.SetPrice;
                                result.totalGSTAmount = Math.ceil(result.totalPage / price.UnitPerSet) * price.GSTPrice;
                            } else {
                                // UOM = 'seconds' | 'minutes' | 'hours' 

                                var totalSelectedDuration = moment.duration('00:00:00');
                                items.forEach((item) => {
                                    var getTotalDuration = moment.duration(moment.duration(Math.floor(item.TotalDuration), 'seconds').asMilliseconds());
                                    var currentHours = getTotalDuration.hours();
                                    currentHours = ("0" + currentHours).slice(-2);
                                    var currentMinutes = getTotalDuration.minutes();
                                    currentMinutes = ("0" + currentMinutes).slice(-2);
                                    var currentSeconds = getTotalDuration.seconds();
                                    currentSeconds = ("0" + currentSeconds).slice(-2);

                                    var maxDuration = currentHours + ":" + currentMinutes + ":" + currentSeconds;
                                    var validateTime = (item.End_Time < item.Start_Time) ? true : (item.Start_Time > maxDuration) ? true : (item.End_Time > maxDuration) ? true : (item.End_Time === item.Start_Time || item.Start_Time === item.End_Time) ? true : false;

                                    var getDuration = validateTime ? 0 : moment.duration(item.Duration);
                                    totalSelectedDuration.add(getDuration);
                                });
                                var Partial_Rate = price.SetPrice;
                                var PartialGSTRate = price.GSTPrice;
                                var UnitPerSet = price.UnitPerSet;
                                var totalSelectedDurationInUOM = Math.ceil(totalSelectedDuration.as(price.UOM));

                                result.totalSelectedDuration = moment.utc(totalSelectedDuration.asMilliseconds()).format('HH:mm:ss');
                                var block = Math.ceil(totalSelectedDurationInUOM / UnitPerSet);
                                result.totalAmount = block * Partial_Rate;
                                result.totalGSTAmount = block * PartialGSTRate;
                                //console.log(result.totalAmount);
                            }
                        }
                    })
                    items.forEach((item) => {
                        item.Price = result.totalAmount;
                        item.GSTPrice = result.totalGSTAmount;
                    });

                    state.shoppingCart.subjectToApproval.totalItemsAmount += item.Price;
                    state.shoppingCart.subjectToApproval.totalWithGstAmount = parseFloat(state.shoppingCart.subjectToApproval.totalWithGstAmount) + parseFloat(item.GSTPrice);
                    return result;
                }
            })
            orderBy(state.shoppingCart.subjectToApproval.items, ['groupKey'], false);
            //END SA


            state.shoppingCart.availableAfterPayment.accessionNumbers = distinct(state.shoppingCart.availableAfterPayment.items.filter((item) => item.Format !== "PHY").map((item) => {
                return item.SourceNo;
            }));
            state.shoppingCart.availableAfterPayment.accessionNumbers = state.shoppingCart.availableAfterPayment.accessionNumbers.filter((el) => {
                return el != null;
            });
            state.shoppingCart.availableAfterPayment.physicalAccessionNumbers = distinct(state.shoppingCart.availableAfterPayment.items.filter((item) => item.Format === "PHY").map((item) => {
                return item.SourceNo;
            }));
            state.shoppingCart.availableAfterPayment.physicalAccessionNumbers = state.shoppingCart.availableAfterPayment.physicalAccessionNumbers.filter((el) => {
                return el != null;
            });
            // availableAfterPayment ??, subjectToApproval ???????
            state.shoppingCart.subjectToApproval.accessionNumbers = distinct(state.shoppingCart.subjectToApproval.flatItems.map((item) => {
                return item.SourceNo;
            })).filter(function (accessionNumber) {
                return state.shoppingCart.availableAfterPayment.accessionNumbers.indexOf(accessionNumber) === -1;
            });

            sessionStorage.setItem('cartItems', JSON.stringify(state.CartItems));
        },
    },
    extraReducers: (builder) => {
        builder.addCase(GetCartItemsAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetCartItemsAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetCartItemsAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            //state.pages_data = action.payload;
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
        });

        builder.addCase(GetPriceRuleAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetPriceRuleAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetPriceRuleAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
            state.priceRules = action.payload ? action.payload.PriceRules.map(item=>{
                item.SetPrice=  parseFloat(parseFloat(item.SetPrice).toFixed(2))
                return item;
            }) : null;
            console.log("cart state.priceRules",state.priceRules)
         
        });
        builder.addCase(DuplicateCartAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(DuplicateCartAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(DuplicateCartAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
        });
        builder.addCase(DeleteCartAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(DeleteCartAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(DeleteCartAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        });

        builder.addCase(GetCartItemsCountAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetCartItemsCountAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetCartItemsCountAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            } else {
                if (!state.isLoadShop) {
                    state.cartCountInfo = action.payload.shops;
                    var getShop = state.cartCountInfo ? state.cartCountInfo.filter((data) => data.CartItemCount > 0) : null;
                    if (getShop && getShop.length > 0) {
                        state.isLoadShop = true;
                        state.shopInfo = {
                            name: getShop[0].Description,
                            code: getShop[0].ShopCode,
                            count: getShop[0].CartItemCount
                        }
                    }

                }
            }
        });

    }
});

export const { changeShopInfo, cartCalculation, updateCartItem, submitCart, selectAllItems, toggleSubmit } = CartSlice.actions;
export const pagesData = (state) => state.cart.pages_data;
export const pagesState = (state) => state.cart;
export const cartCountInfo = (state) => state.cart.cartCountInfo;
export const shopInfo = (state) => state.cart.shopInfo;
export const shoppingCart = (state) => state.cart.shoppingCart;
export const CartItems = (state) => state.cart.CartItems;

export const reCalculateData = (data) => (dispatch, getState) => {
    dispatch(updateCartItem(data));
    setTimeout(() => {
        var items = { CartItems: getState().cart.CartItems }
        dispatch(cartCalculation(items));
    }, 100);
};

export const selectAllItemsChecked = (data) => (dispatch, getState) => {
    dispatch(selectAllItems());
    setTimeout(() => {
        var items = { CartItems: getState().cart.CartItems }
        dispatch(cartCalculation(items));
    }, 100);
};

export const shopInitial = (data) => (dispatch, getState) => {
    var sessionItems = JSON.parse(sessionStorage.getItem('cartItems'));
    data.CartItems.forEach((item, index) => {
        sessionItems.forEach((sesItem, sesIndex) => {
            if (item.CartItemId === sesItem.CartItemId) {
                item.checked = false;
                item.Start_Time = sesItem.Start_Time ? sesItem.Start_Time : '00:00:01';
                item.End_Time = sesItem.End_Time ? sesItem.End_Time : '00:00:02';
                item.First_Few_Words = sesItem.First_Few_Words;
                item.First_Few_Words_touched = 1;
                item.Last_Few_Words = sesItem.Last_Few_Words;
                item.Last_Few_Words_touched = 1;
                item.PagesNeeded = sesItem.PagesNeeded;
                item.Format = sesItem.Format;
                item.FullOrPartial = sesItem.FullOrPartial;
            }
        })
    });
    dispatch(cartCalculation(data));
};

export default CartSlice.reducer;
